import axios from 'axios';
import React from 'react';
import { toast } from 'react-toastify';
import { serverURL } from '../../constants';

const AdminTable = ({ admin, user }) => {

    async function removeAdmin(email) {
        if (window.confirm(`Remove ${email} as admin?`)) {
            const response = await axios.post(serverURL + '/api/removeadmin', { email });
            if (response.data.success) {
                toast.success(response.data.message);
                window.location.reload();
            }
        }
    }

    async function addAdmin(email) {
        if (window.confirm(`Make ${email} an admin? They will also get lifetime access.`)) {
            const response = await axios.post(serverURL + '/api/addadmin', { email });
            if (response.data.success) {
                toast.success(response.data.message);
                window.location.reload();
            }
        }
    }

    return (
        <div>
            <div className='bg-blue-50 border border-blue-200 rounded-lg p-3 text-sm text-blue-800 mb-4'>
                <strong>Note:</strong> Making a user an admin also gives them lifetime (forever) access to all features.
            </div>

            <h3 className='font-bold text-base mb-3'>Current Admins</h3>
            <div className='bg-white rounded-lg border border-gray-200 overflow-hidden mb-6'>
                <table className='w-full'>
                    <thead className='bg-gray-50 border-b border-gray-200'>
                        <tr>
                            <th className='text-left px-4 py-3 text-xs font-bold text-gray-500 uppercase'>Email</th>
                            <th className='text-left px-4 py-3 text-xs font-bold text-gray-500 uppercase'>Name</th>
                            <th className='text-left px-4 py-3 text-xs font-bold text-gray-500 uppercase'>Role</th>
                            <th className='text-left px-4 py-3 text-xs font-bold text-gray-500 uppercase'>Action</th>
                        </tr>
                    </thead>
                    <tbody className='divide-y divide-gray-100'>
                        {admin.map(a => (
                            <tr key={a._id} className='hover:bg-gray-50'>
                                <td className='px-4 py-3 text-sm'>{a.email}</td>
                                <td className='px-4 py-3 text-sm'>{a.mName}</td>
                                <td className='px-4 py-3'>
                                    <span className={`text-xs font-medium px-2 py-1 rounded-full ${a.type === 'main' ? 'bg-yellow-50 text-yellow-700' : 'bg-gray-100 text-gray-600'}`}>
                                        {a.type === 'main' ? 'Main Admin' : 'Admin'}
                                    </span>
                                </td>
                                <td className='px-4 py-3'>
                                    {a.type === 'main' ? (
                                        <span className='text-xs text-gray-400'>Cannot remove</span>
                                    ) : (
                                        <button onClick={() => removeAdmin(a.email)} className='text-xs font-medium text-red-600 hover:text-red-800'>Remove</button>
                                    )}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {user.length > 0 && (
                <>
                    <h3 className='font-bold text-base mb-3'>Add New Admin</h3>
                    <p className='text-sm text-gray-500 mb-3'>Select a user to promote to admin</p>
                    <div className='bg-white rounded-lg border border-gray-200 overflow-hidden'>
                        <table className='w-full'>
                            <thead className='bg-gray-50 border-b border-gray-200'>
                                <tr>
                                    <th className='text-left px-4 py-3 text-xs font-bold text-gray-500 uppercase'>Email</th>
                                    <th className='text-left px-4 py-3 text-xs font-bold text-gray-500 uppercase'>Name</th>
                                    <th className='text-left px-4 py-3 text-xs font-bold text-gray-500 uppercase'>Action</th>
                                </tr>
                            </thead>
                            <tbody className='divide-y divide-gray-100'>
                                {user.map(u => (
                                    <tr key={u._id} className='hover:bg-gray-50'>
                                        <td className='px-4 py-3 text-sm'>{u.email}</td>
                                        <td className='px-4 py-3 text-sm'>{u.mName}</td>
                                        <td className='px-4 py-3'>
                                            <button onClick={() => addAdmin(u.email)} className='text-xs font-medium bg-black text-white px-3 py-1.5 rounded-lg hover:bg-gray-800'>Make Admin</button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </>
            )}
        </div>
    );
};

export default AdminTable;
